import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import axios from "axios";
import { ServiceUrl } from "../../../utils/serviceUrl";
import { DB_POSTFIX } from "../../../utils";
import PsContext from "../../../context";

const DayOrderSocial = () => {
  const context = useContext(PsContext);
  const [dayOrder, setDayOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  const today = new Date();
  const todayName = days[today.getDay()];

  const formattedDate = today.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);
    const res = await axios.get(ServiceUrl.DAY_ORDER + "?sadb=" + DB_POSTFIX);
    // console.log("sss", res);
    if (res.data.status === "1") {
      const data = res.data.data;
      const type = res.data.type;
      if (type === "holiday") {
        const holiday = data[0];
        setDayOrder(`Holiday: ${holiday.holiday_name}`);
      } else if (type === "day_order") {
        const dayOrder = data[0];
        setDayOrder(dayOrder.day_order_value || dayOrder.day_order_text);
      } else {
        setDayOrder("No Day Order");
      }
    }
    setLoading(false);
  };

  return (
    <section style={{ backgroundColor: "#f4f0eb" }}>
      <Container>
        <Row className="justify-content-start py-2">
          <Col
            md={6}
            sm={6}
            className="d-flex justify-content-start align-items-center gap-3"
          >
            <div
              style={{ fontSize: "18px", letterSpacing: "1px" }}
              className="fw-bold"
            >
              Today's Day Order
            </div>
            <div className="img">
              <img
                src="https://portal.aei.edu.in//files_list/aei/drsacoe/fm/website/clock.png"
                alt="clock"
                style={{ width: "40px" }}
              />
            </div>
            <div
              className="count-number pe-3"
              style={{
                fontSize: "20px",
                fontWeight: "bold",
                borderRight: "1px solid",
              }}
            >
              {loading ? "Loading..." : dayOrder}
            </div>

            <div
              style={{ fontSize: "18px", letterSpacing: "1px" }}
              className="fw-bolder"
            >
              {formattedDate} - {todayName}
            </div>
          </Col>

          <Col md={6} className="d-flex align-items-center justify-content-end">
            <ul className="list-unstyled d-flex gap-3 mb-0">
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={context.settingValue("web_site_social_facebook")}
                >
                  <i className="fab fa-facebook fa-lg text-primary"></i>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={context.settingValue("web_site_social_twitter")}
                >
                  <img
                    src="https://portal.aei.edu.in//files_list/aei/gacw/fm/twitter.png"
                    alt="X"
                    width="20"
                    height="20"
                  />
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={context.settingValue("web_site_social_instagram")}
                >
                  <i
                    className="fab fa-instagram fa-lg"
                    style={{ color: "orangered" }}
                  ></i>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={context.settingValue("web_site_social_youtube")}
                >
                  <i className="fab fa-youtube fa-lg text-danger"></i>
                </a>
              </li>
              <li>
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://wa.me/"
                >
                  <i className="fab fa-whatsapp fa-lg text-success"></i>
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default DayOrderSocial;
